<template>
  <v-navigation-drawer
    app
    dark
    v-model="drawer"
    clipped
    floating
    class="elevation-2"
    overflow
    v-bind="$attrs"
    data-cy="menu">
    <slot name="menu-before-list"></slot>
    <v-list id="menulist" data-cy="menu-list" :dense="$vuetify.breakpoint[$theme.options.compact.drawer]">
      <core-menulist :items="items"></core-menulist>
    </v-list>
    <slot name="menu-after-list"></slot>
  </v-navigation-drawer>
</template>
<script>
export default {
  props: {
    routes: { type: Array, default: () => null }
  },
  computed: {
    items () {
      let routes = this.routes
      if (routes === null) { routes = this.$router.options.routes }
      var item = this.filterAvaliables(routes).map(
        function (p) {
          return p
        }
      )
      return item
    },
    drawer: {
      get () {
        return this.$store.getters.drawer
      },
      set (value) {
        if (!value && this.drawer) { this.$store.commit('drawer') }
      }
    }
  },
  methods: {
    filterAvaliables (routes) {
      const th = this
      routes = routes.filter(p => p.menu)
      routes.forEach(function (p) {
        if (p.children) {
          p.children = th.filterAvaliables(p.children)
        }
      })
      return routes
    }
  }
}
</script>
